export const PATH_HOME = '/';

export const PATH_LOGIN = '/login';
export const PATH_SIGNUP = '/signup';
export const PATH_ERROR_500 = '/error/500';

export const PATH_DASHBOARD = '/dashboard';
export const PATH_HISTORY = '/history';
export const PATH_GROUP = '/group/:groupId';
export const PATH_PROFILE = '/profile';
export const PATH_PROFILE_PASSCODE = '/profile/passcode';
export const PATH_STANDALONE = '/standalone';
